import React, { memo } from 'react';
import { View, Text, StyleSheet, Image } from '@react-pdf/renderer';

const BORDER_COLOR = '#8A9EAF';
const BORDER_STYLE = 'solid';

const styles = StyleSheet.create({
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderBottomWidth: 0,
    borderRadius: 0,
    overflow: 'hidden',
    marginTop: 20,
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row',
  },

  tableCol1Header: {
    width: 21 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    paddingTop: 4,
    paddingBottom: 4,
  },
  tableCol3Header: {
    width: 30 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    paddingTop: 4,
    paddingBottom: 4,
    borderTopLeftRadius: 0,
  },
  tableColLastHeader: {
    width: 28 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 0,
    paddingTop: 4,
    paddingBottom: 4,
    borderTopRightRadius: 0,
  },
  tableColFirstHeader: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    borderRightWidth: 1,
    paddingTop: 4,
    paddingBottom: 4,
    borderTopLeftRadius: 0,
    alignItems: 'center',
  },

  tableColFirst: {
    width: 6 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    alignItems: 'center',
  },
  tableCol1: {
    width: 21 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderBottomWidth: 1,
  },
  tableCol3: {
    width: 30 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
  },
  tableCollast: {
    width: 28 + '%',
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderBottomWidth: 1,
    borderTopWidth: 0,
    borderRightWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    paddingLeft: 3,
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },
  tableCell: {
    margin: 5,
    fontSize: 7,
    marginTop: 9,
    marginBottom: 9,
    fontFamily: 'Roboto',
    fontWeight: '400',
    paddingLeft: 3,
    paddingRight: 3,
  },
  tableCell__images: {
    margin: 5,
    marginTop: 9,
    marginBottom: 9,
    paddingLeft: 3,
    flexDirection: 'row',
  },
  image: {
    width: '27px',
    height: '27px',
    borderRadius: 5,
  },
  margin__right: {
    paddingRight: 4,
  },
});

const InspectionParts = ({ partsData }) => {
  return (
    <>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={styles.tableColFirstHeader}>
            <Text style={styles.tableCellHeader}>Sr#</Text>
          </View>
          <View style={styles.tableCol1Header}>
            <Text style={styles.tableCellHeader}>Part Name</Text>
          </View>
          <View style={styles.tableCol3Header}>
            <Text style={styles.tableCellHeader}>Photos</Text>
          </View>
          <View style={styles.tableCol1Header}>
            <Text style={styles.tableCellHeader}>Condition</Text>
          </View>
          <View style={styles.tableColLastHeader}>
            <Text style={styles.tableCellHeader}>Notes</Text>
          </View>
        </View>

        {partsData?.map((part, i) => (
          /* ---------------Parts Map---------- */
          <View style={styles.tableRow} key={i++}>
            <View style={styles.tableColFirst}>
              <Text style={styles.tableCell}>{i + 1}</Text>
            </View>
            <View style={styles.tableCol1}>
              <Text style={styles.tableCell}>
                {part?.cw_parts_list?.name ||
                  part?.pw_parts_list?.name ||
                  part?.template_item?.itemName}
              </Text>
            </View>
            <View style={styles.tableCol3}>
              <View style={styles.tableCell__images}>
                {part?.photos?.length &&
                  part.photos.map((img, ind) => {
                    return (
                      <View style={styles.margin__right}>
                        <Image
                          key={ind++}
                          src={{
                            uri: img || 'data:,',
                            method: 'GET',
                            headers: { 'Cache-Control': 'no-cache' },
                          }}
                          style={styles.image}
                        />
                      </View>
                    );
                  })}
              </View>
            </View>
            <View style={styles.tableCol1}>
              <Text style={styles.tableCell}>
                {part?.condition === 'bad'
                  ? 'Immediate Action Required'
                  : part?.condition === 'moderate'
                  ? 'Needs Attention'
                  : 'OK'}
              </Text>
            </View>
            <View style={styles.tableCollast}>
              <Text style={[styles.tableCell, { paddingRight: 22 }]}>
                {part?.notes}
              </Text>
            </View>
          </View>
        ))}
      </View>
    </>
  );
};
export default memo(InspectionParts);
